const areas = [
  "Barri Vell", "Eixample", "Mercadal", "Montilivi", "Palau",
  "Santa Eugènia", "Sant Narcís", "Pont Major", "Taialà",
  "Fontajau", "Pedret", "Devesa", "Salt", "Sarrià de Ter",
  "Quart", "Vilablareix", "Fornells de la Selva", "Bescanó",
  "Celrà", "Cassà de la Selva", "Banyoles",
];

export default function ServiceAreas() {
  return (
    <section className="py-20 md:py-24 bg-[#330000]" style={{ fontFamily: "'Montserrat', sans-serif" }}>
      <div className="max-w-7xl mx-auto px-4 md:px-8 text-center">
        <span className="inline-block text-xs font-700 text-[#FF6666] uppercase tracking-widest mb-3" style={{ fontWeight: 700 }}>
          Cobertura local
        </span>
        <h2 className="text-3xl md:text-4xl font-800 text-white mb-4" style={{ fontWeight: 800 }}>
          Vaciado de pisos en Girona y toda la comarca
        </h2>
        <p className="text-red-200 max-w-2xl mx-auto mb-10 text-base leading-relaxed">
          Cubrimos Girona ciudad en todos sus barrios y las principales poblaciones del Gironès. ¿No ves tu municipio? Consúltanos, seguramente también llegamos.
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          {areas.map((area) => (
            <span
              key={area}
              className="px-4 py-2 rounded-full text-sm font-600 text-white bg-white/10 border border-white/20 hover:bg-[#ff0000] hover:border-[#ff0000] transition-all duration-200 cursor-default"
              style={{ fontWeight: 600 }}
            >
              {area}
            </span>
          ))}
        </div>
        <div className="mt-10 px-4 sm:px-0">
          <a
            href="tel:+34602365996"
            className="inline-flex items-center justify-center gap-2 bg-[#ff0000] text-white px-6 py-4 rounded-full text-sm font-700 whitespace-nowrap cursor-pointer transition-all duration-300 hover:bg-[#cc0000] hover:scale-105 w-full sm:w-auto max-w-xs mx-auto"
            style={{ fontWeight: 700 }}
          >
            <i className="ri-phone-fill"></i> Consulta tu zona: 602 36 59 96
          </a>
        </div>
      </div>
    </section>
  );
}
